import React, { useState, useEffect } from "react";
import { PiSidebar, PiSignInFill } from "react-icons/pi";
import logo from "../logo/logo.jpg";
import { NavLink, Outlet } from "react-router-dom";
import Aos from "aos";
import { useAuth0 } from "@auth0/auth0-react";
import Home from "../Component/Home";
import Login from "../Component/Login";

const Dashboard = () => {
  const { loginWithRedirect, logout, isAuthenticated, user } = useAuth0();

  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  //login interpretations
  const [isLoggedIn, setLoggedIn] = useState(/* your initial login status */);
  //  const history = useHistory();

  // Function to handle login
  const handleLogin = () => {
    // Your login logic goes here
    // For simplicity, let's just toggle the login status
    setLoggedIn(!isAuthenticated);
    //  history.push('/');
  };

  const handleNavItemClick = (event) => {
    // Check if the user is not logged in, show alert
    if (!isAuthenticated) {
      alert(
        "Please login to access this feature. If not created click login button to singup"
      );
      event.preventDefault();
      // history.push('/login');
    } else {
      // Handle navigation logic here
      // For simplicity, let's just navigate to the corresponding page
      // You can use react-router-dom or your preferred routing mechanism
      // For example: history.push('/desired-page');
      // <Redirect to='/login' />
    }
  };

  return (
    <div>
      <header className="flex flex-wrap sm:justify-start sm:flex-nowrap z-50  w-full bg-purple-600 border-b hover:bg-blue-500 border-white/[.5] text-sm py-3 sm:py-0">
        <nav
          className="relative max-w-[85rem] w-full mx-auto px-4 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8"
          aria-label="Global"
        >
          <div className="flex items-center justify-between">
            <NavLink to={"/"}>
              {" "}
              <div
                className="flex gap-3 hover:scale-105 transition-transform duration-500 ease-in-out rounded-xl w-full object-cover"
                data-aos="fade-right"  onClick={handleNavItemClick}
              >
                {" "}
                <div>
                  <a
                    className="text-xl font-semibold text-white "
                    href="#"
                    aria-label="Brand"
                  >
                    BTS&nbsp;ARMY&nbsp;STORE{" "}
                  </a>
                </div>{" "}
                <div>
                  <img
                    className="inline-block h-7 w-14 rounded-sm ring-2 ring-white dark:ring-gray-800"
                    src={logo}
                    alt="Image Description"
                  />
                </div>
              </div>{" "}
            </NavLink>
            <div className="sm:hidden">
              <button
                type="button"
                className="hs-collapse-toggle p-2 inline-flex justify-center items-center gap-2 rounded-md border border-white/[.5] font-medium text-white/[.5] shadow-sm align-middle hover:bg-white/[.1] hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-600 transition-all text-sm"
                data-hs-collapse="#navbar-collapse-with-animation"
                aria-controls="navbar-collapse-with-animation"
                aria-label="Toggle navigation"
              >
                <svg
                  className="hs-collapse-open:hidden w-4 h-4"
                  width="16"
                  height="16"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
                  />
                </svg>
                <svg
                  className="hs-collapse-open:block hidden w-4 h-4"
                  width="16"
                  height="16"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg>
              </button>
            </div>
          </div>

          <div
            id="navbar-collapse-with-animation"
            className="hs-collapse hidden overflow-hidden transition-all duration-300 basis-full grow sm:block"
          >
            <div className="flex flex-col gap-y-4 gap-x-0 mt-5 sm:flex-row sm:items-center sm:justify-end sm:gap-y-0 sm:gap-x-7 sm:mt-0 sm:pl-7">
              {/* {isAuthenticated ? (
                   <NavLink to={"/"}> <a  className="font-medium text-white hover:text-gray-300 sm:py-6" href="#" aria-current="page" onClick={handleNavItemClick}>Home</a> </NavLink>
          ) : (
            <NavLink to={"/"}> <a  className="font-medium text-white hover:text-gray-300 sm:py-6" href="#" aria-current="page" onClick={handleNavItemClick}>Home</a> </NavLink>

          )} */}
              <NavLink to={"/"}>
                {" "}
                <a
                  className="font-medium text-white hover:text-gray-300 sm:py-6"
                  href="#"
                  aria-current="page"
                  onClick={handleNavItemClick}
                >
                  Home
                </a>{" "}
              </NavLink>
              <NavLink to={"/gallery"}>
                {" "}
                <a
                  className="font-medium text-white hover:text-gray-300 sm:py-6"
                  href="#"
                  onClick={handleNavItemClick}
                >
                  Gallery
                </a>{" "}
              </NavLink>
              <NavLink to={"/orders"}>
                {" "}
                <a
                  className="font-medium text-white hover:text-gray-300 sm:py-6"
                  href="#"
                  onClick={handleNavItemClick}
                >
                  Order
                </a>{" "}
              </NavLink>
              <NavLink to={"/aboutus"}>
                {" "}
                <a
                  className="font-medium text-white hover:text-gray-300 sm:py-6"
                  href="#"
                  onClick={handleNavItemClick}
                >
                  About Us
                </a>{" "}
              </NavLink>
              <NavLink to={"/enquiry"}>
                {" "}
                <a
                  className="font-medium text-white hover:text-gray-300 sm:py-6"
                  href="#"
                  // onClick={handleNavItemClick}
                >
                  Enquiry
                </a>{" "}
              </NavLink>
              {isAuthenticated && (
                <p className="text-yellow-400 hover:text-white">{user.name}</p>
              )}
              {isAuthenticated ? (
                <h4 to={""}>
                  {" "}
                  <a
                    className="flex items-center gap-x-2 font-medium text-white/[.8] hover:text-white sm:border-l sm:border-white/[.3] sm:my-6 sm:pl-6"
                    href="#"
                  >
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAY9JREFUSEvN1D9IlVEYBvCfDuViVJBYtDVIGQZJ1lCg4NDSKtHSUjg4JbaJi+EghJNR0CBBS4OrKDiIUwVBWpSL0RIUGaljlPLKuXHz3u/e+2kXPNMZznkfnj/v06DOp6HO8x0YgAu4jsu4mlgv4iVmsJylRDUGhzCGe2jMGPIH4xjBr91vKgGcwhzasYYJvMabNKQTXRjEUbzFTXwsBqnG4AHO4Q5+ZDBowVPcwDdcwafC22oAeUI2hduYTX7t/M0CCO0ncTcHwmGsIqTtKBhfDuAkphPVvAzvJ8MfYqgcg9AvhgdIJYZZxMKv91hCRPsficLIkCXkyXOKWTZjAz9xrB4AR7COTcS9xOT9SnQJr5JM57M03o/JwxjFIwz875g2pQVrRS/m95KSSuY/xy0soLvWTY6qOJ7obmVMjxQ9SUv5FRfxpRaA06nYTuADHuNZimD8D+Cohn604Tt68C5P2Z1JRfaXcgaL6J8A+pynrovfRvz6cA1n8RsrSe8XRRVegp+3a/Js+J665uABbANt30QZBx56CwAAAABJRU5ErkJggg==" />
                    <button
                      onClick={() =>
                        logout({
                          logoutParams: { returnTo: window.location.origin },
                        })
                      }
                    >
                      Log Out
                    </button>
                  </a>{" "}
                </h4>
              ) : (
                <a
                  className="flex items-center gap-x-2 font-medium text-white/[.8] hover:text-white sm:border-l sm:border-white/[.3] sm:my-6 sm:pl-6"
                  href="#"
                >
                  <svg
                    className="w-4 h-4"
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                  </svg>
                  <button onClick={() => loginWithRedirect()}>Log In </button>
                  {/* <button onClick={handleLogin}></button> */}
                  {/* () => loginWithRedirect() */}
                </a>
              )}
            </div>
          </div>
        </nav>
      </header>
      {!isAuthenticated ? <code></code> : <code></code>}
      <Outlet />
    </div>
  );
};

export default Dashboard;
